'use client';

import RichTextCopy from 'components/shared/RichTextCopy/RichTextCopy';
import { BLOCKS, INLINES } from '@contentful/rich-text-types';
import renderEmbeddedEntry from 'components/nodes/EmbeddedEntry';
import { useDisclosureNumberingMap } from 'contexts/DisclosureProvider';
import type { CardEyebrowProps } from './types';
import { liveUpdateAttrs } from 'libs/contentful/utils';

export const CardEyebrow = ({ eyebrow, cardId }: CardEyebrowProps) => {
  const disclosureNumberingMap = useDisclosureNumberingMap();

  return (
    <RichTextCopy
      copy={eyebrow}
      {...liveUpdateAttrs(cardId, 'textEyebrow')}
      additionalOptions={{
        renderNode: {
          [BLOCKS.PARAGRAPH]: (_, children) => <div className="font-sans font-semibold text-eyebrow">{children}</div>,
          [INLINES.EMBEDDED_ENTRY]: (node, children) =>
            renderEmbeddedEntry(node, children, eyebrow, disclosureNumberingMap),
        },
      }}
    />
  );
};
